var _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSushi(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3F4963"
    },
    cx: 255.996,
    cy: 255.996,
    r: 247.946
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 255.996,
    cy: 255.996,
    r: 217.355
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFD553"
    },
    cx: 255.996,
    cy: 255.996,
    r: 165.49
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M256.001,422.376c-91.74,0-166.376-74.636-166.376-166.376S164.261,89.623,256.001,89.623 s166.376,74.636,166.376,166.376S347.74,422.376,256.001,422.376z M256.001,90.697c-91.148,0-165.302,74.154-165.302,165.302 s74.154,165.302,165.302,165.302s165.302-74.155,165.302-165.302S347.149,90.697,256.001,90.697z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CF5C5"
    },
    d: "M391.91,160.96c-43.165,4.216-76.901,40.602-76.901,84.875c0,47.104,38.186,85.29,85.29,85.29 c1.215,0,2.423-0.033,3.625-0.085c11.454-22.534,17.914-48.032,17.914-75.041C421.84,220.643,410.767,187.875,391.91,160.96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6CF5C5"
    },
    d: "M120.09,160.96c43.165,4.216,76.901,40.602,76.901,84.875c0,47.104-38.186,85.29-85.29,85.29 c-1.215,0-2.423-0.033-3.625-0.085c-11.454-22.534-17.914-48.032-17.914-75.041C90.16,220.643,101.234,187.875,120.09,160.96z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF9596"
    },
    d: "M256.001,256c-60.137,0-114.189,25.98-151.603,67.306c25.811,58.05,83.975,98.534,151.603,98.534 s125.792-40.484,151.603-98.534C370.19,281.98,316.138,256,256.001,256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3F4963"
    },
    cx: 143.519,
    cy: 201.093,
    r: 14.576
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#3F4963"
    },
    cx: 368.495,
    cy: 201.093,
    r: 14.576
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6376"
    },
    d: "M159.111,252.043h-31.186c-4.446,0-8.05-3.604-8.05-8.05c0-4.446,3.604-8.05,8.05-8.05h31.186 c4.446,0,8.05,3.604,8.05,8.05C167.161,248.438,163.557,252.043,159.111,252.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6376"
    },
    d: "M384.083,252.043h-31.186c-4.446,0-8.05-3.604-8.05-8.05c0-4.446,3.604-8.05,8.05-8.05h31.186 c4.446,0,8.05,3.604,8.05,8.05C392.133,248.438,388.53,252.043,384.083,252.043z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F4963"
    },
    d: "M237.753,241.97c-14.502,0-26.3-11.798-26.3-26.299c0-4.446,3.604-8.05,8.05-8.05 s8.05,3.604,8.05,8.05c0,5.624,4.576,10.199,10.2,10.199c5.624,0,10.201-4.576,10.201-10.199c0-4.446,3.604-8.05,8.05-8.05 c4.446,0,8.05,3.604,8.05,8.05C264.055,230.172,252.257,241.97,237.753,241.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3F4963"
    },
    d: "M274.255,241.97c-14.502,0-26.3-11.798-26.3-26.299c0-4.446,3.604-8.05,8.05-8.05 c4.446,0,8.05,3.604,8.05,8.05c0,5.624,4.576,10.199,10.2,10.199s10.2-4.576,10.2-10.199c0-4.446,3.604-8.05,8.05-8.05 s8.05,3.604,8.05,8.05C300.556,230.172,288.756,241.97,274.255,241.97z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M72.462,193.158c-2.061,0-4.12-0.786-5.692-2.357c-3.144-3.144-3.144-8.241,0-11.385l15.632-15.635 c3.144-3.144,8.24-3.144,11.385-0.001c3.144,3.144,3.144,8.241,0,11.385L78.155,190.8 C76.583,192.372,74.523,193.158,72.462,193.158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M439.577,259.86c-2.06,0-4.12-0.786-5.692-2.357c-3.144-3.144-3.144-8.241-0.001-11.385 l15.632-15.635c3.144-3.144,8.24-3.144,11.385,0c3.144,3.144,3.144,8.241,0,11.385l-15.632,15.635 C443.697,259.074,441.637,259.86,439.577,259.86z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M74.609,301.057c-2.061,0-4.121-0.786-5.693-2.358l-15.632-15.635 c-3.144-3.144-3.143-8.241,0-11.385c3.144-3.143,8.241-3.143,11.385,0.001l15.632,15.635c3.144,3.144,3.143,8.241,0,11.385 C78.729,300.271,76.668,301.057,74.609,301.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M439.537,198.464c-2.06,0-4.121-0.786-5.693-2.358l-15.633-15.635 c-3.144-3.144-3.143-8.241,0.001-11.385c3.144-3.143,8.24-3.143,11.385,0l15.633,15.635c3.144,3.144,3.143,8.241,0,11.385 C443.657,197.678,441.596,198.464,439.537,198.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M124.773,405.456c-2.06,0-4.121-0.786-5.693-2.358l-15.632-15.635 c-3.144-3.144-3.143-8.241,0-11.385c3.144-3.143,8.241-3.143,11.385,0l15.632,15.635c3.144,3.144,3.143,8.241-0.001,11.385 C128.894,404.671,126.833,405.456,124.773,405.456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M205.612,454.938c-2.06,0-4.12-0.786-5.692-2.357c-3.144-3.144-3.144-8.241-0.001-11.385 l9.805-9.806c3.144-3.144,8.24-3.144,11.385,0c3.144,3.144,3.144,8.241,0,11.385l-9.805,9.806 C209.732,454.152,207.673,454.938,205.612,454.938z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M379.786,419.679c-2.06,0-4.12-0.786-5.692-2.357l-9.806-9.805c-3.144-3.144-3.144-8.241,0-11.385 c3.144-3.144,8.24-3.144,11.385,0l9.806,9.805c3.144,3.144,3.144,8.241,0,11.385C383.907,418.893,381.846,419.679,379.786,419.679z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M429.963,358.141c-2.06,0-4.12-0.786-5.692-2.357l-9.806-9.805c-3.144-3.144-3.144-8.241,0-11.385 c3.144-3.144,8.24-3.144,11.385,0l9.806,9.805c3.144,3.144,3.144,8.241,0,11.385C434.084,357.354,432.024,358.141,429.963,358.141z "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M299.082,454.026c-2.06,0-4.12-0.786-5.692-2.357c-3.144-3.144-3.144-8.241,0-11.385l9.805-9.806 c3.144-3.144,8.24-3.144,11.385,0c3.144,3.144,3.144,8.241,0,11.385l-9.805,9.806C303.202,453.239,301.142,454.026,299.082,454.026 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M298.227,85.482c-2.06,0-4.121-0.786-5.693-2.358l-15.633-15.635 c-3.144-3.144-3.143-8.241,0.001-11.385c3.144-3.143,8.241-3.143,11.385,0l15.632,15.635c3.144,3.144,3.143,8.241,0,11.385 C302.348,84.695,300.287,85.482,298.227,85.482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M120.693,126.716c-2.06,0-4.12-0.786-5.692-2.357c-3.144-3.144-3.144-8.241,0-11.385l9.805-9.806 c3.144-3.144,8.24-3.144,11.385-0.001c3.144,3.144,3.144,8.241,0,11.385l-9.805,9.806 C124.814,125.931,122.753,126.716,120.693,126.716z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M198.814,87.048c-2.06,0-4.12-0.786-5.692-2.357l-9.806-9.805 c-3.144-3.144-3.144-8.241-0.001-11.385c3.144-3.144,8.24-3.144,11.385,0l9.806,9.805c3.144,3.144,3.144,8.241,0.001,11.385 C202.935,86.261,200.874,87.048,198.814,87.048z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2F3953"
    },
    d: "M373.245,122.109c-2.06,0-4.12-0.786-5.692-2.357c-3.144-3.144-3.144-8.241-0.001-11.385 l9.805-9.806c3.144-3.144,8.24-3.144,11.385,0c3.144,3.144,3.144,8.241,0.001,11.385l-9.805,9.806 C377.367,121.323,375.306,122.109,373.245,122.109z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6376"
    },
    d: "M256.001,349.129c-37.031,0-69.891,18.173-90.146,46.064c4.517,2.931,9.173,5.665,13.978,8.155 c17.395-23.131,45.063-38.119,76.168-38.119c31.104,0,58.773,14.988,76.168,38.119c4.805-2.489,9.462-5.223,13.978-8.155 C325.891,367.302,293.03,349.129,256.001,349.129z M256.001,292.04c-53.513,0-101.273,25.088-132.15,64.115 c3.324,4.379,6.856,8.591,10.59,12.615c27.834-36.802,71.964-60.63,121.56-60.63s93.724,23.827,121.559,60.63 c3.734-4.024,7.266-8.236,10.59-12.615C357.274,317.128,309.513,292.04,256.001,292.04z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M237.753,241.97c7.084,0,13.518-2.82,18.251-7.389c4.734,4.569,11.167,7.389,18.25,7.389c14.502,0,26.3-11.798,26.3-26.299 c0-4.446-3.604-8.05-8.05-8.05c-4.447,0-8.05,3.604-8.05,8.05c0,5.624-4.577,10.199-10.2,10.199s-10.2-4.576-10.2-10.199 c0-4.446-3.603-8.05-8.05-8.05c-4.447,0-8.05,3.604-8.05,8.05c0,5.624-4.577,10.199-10.201,10.199s-10.2-4.576-10.2-10.199 c0-4.446-3.604-8.05-8.05-8.05s-8.05,3.604-8.05,8.05C211.453,230.172,223.251,241.97,237.753,241.97z M143.518,186.523 c-8.05,0-14.576,6.526-14.576,14.576c0,8.051,6.526,14.577,14.576,14.577c8.05,0,14.576-6.526,14.576-14.577 C158.094,193.049,151.568,186.523,143.518,186.523z M437.019,74.98C388.666,26.629,324.381,0,256.001,0S123.334,26.629,74.981,74.98 C26.629,123.333,0.001,187.62,0.001,256s26.629,132.667,74.98,181.02C123.334,485.371,187.62,512,256.001,512 s132.667-26.629,181.018-74.98c48.353-48.352,74.98-112.639,74.98-181.02S485.372,123.333,437.019,74.98z M425.635,425.633 c-45.312,45.311-105.556,70.265-169.634,70.265s-124.323-24.954-169.634-70.265C41.055,380.324,16.101,320.079,16.101,256 S41.055,131.676,86.366,86.367C131.678,41.055,191.922,16.1,256.001,16.1s124.323,24.954,169.634,70.265 c45.311,45.311,70.265,105.555,70.265,169.633S470.946,380.324,425.635,425.633z M256.001,82.462 c-95.69,0-173.538,77.848-173.538,173.538s77.847,173.538,173.538,173.538S429.539,351.69,429.539,256S351.69,82.462,256.001,82.462 z M256.001,98.562c48.613,0,92.148,22.152,121.05,56.888c-17.471,4.482-33.362,13.96-45.716,27.502 c-15.713,17.222-24.366,39.555-24.366,62.885c0,2.828,0.132,5.652,0.385,8.461c-16.668-4.167-33.904-6.347-51.354-6.347 c-17.446,0-34.679,2.179-51.345,6.345c0.253-2.808,0.385-5.631,0.385-8.459c0-23.329-8.654-45.663-24.366-62.885 c-12.356-13.543-28.249-23.021-45.723-27.504C163.854,120.713,207.387,98.562,256.001,98.562z M98.563,256 c0-31.857,9.52-61.528,25.851-86.337c17.014,2.82,32.618,11.261,44.366,24.138c13.001,14.249,20.161,32.728,20.161,52.033 c0,4.515-0.392,9.015-1.165,13.43c-29.854,10.146-57.346,26.874-80.218,49.187C101.741,292.037,98.563,274.383,98.563,256z  M256.001,413.438c-62.265,0-116.202-36.335-141.725-88.914c36.96-38.5,88.281-60.474,141.725-60.474s104.765,21.975,141.725,60.474 C372.202,377.104,318.266,413.438,256.001,413.438z M324.234,259.268c-0.774-4.416-1.166-8.917-1.166-13.433 c0-19.305,7.16-37.784,20.161-52.033c11.746-12.876,27.348-21.315,44.358-24.137c16.331,24.807,25.851,54.477,25.851,86.334 c0,18.383-3.178,36.037-8.995,52.452C381.573,286.141,354.085,269.414,324.234,259.268z M256.001,30.589 c-124.292,0-225.411,101.119-225.411,225.41s101.12,225.41,225.411,225.41S481.412,380.292,481.412,256 S380.292,30.589,256.001,30.589z M256.001,465.31c-115.414,0-209.311-93.896-209.311-209.31S140.586,46.689,256.001,46.689 S465.312,140.585,465.312,256S371.414,465.31,256.001,465.31z M368.492,186.523c-8.05,0-14.576,6.526-14.576,14.576 c0,8.051,6.526,14.577,14.576,14.577s14.576-6.526,14.576-14.577C383.068,193.049,376.542,186.523,368.492,186.523z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSushi);
export default __webpack_public_path__ + "static/media/sushi.864b72d17b23360a5a92f08f87774d63.svg";
export { ForwardRef as ReactComponent };